<template>
    <div></div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {},
        computed: {},
        components: {},
        mounted() {
            const div = document.createElement('div');
            div.innerHTML = this.$route.query.htmls;
            document.body.appendChild(div);
            document.forms[0].submit();
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// apply.vue?38c757c2